import type {Module} from "vuex";
import type {RootState} from "@/store/types";

import countries from "./db/countries";
import providedProducts from "./db/providedProducts";

const db: Module<Record<string, never>, RootState> = {
    namespaced: true,
    modules: {
        countries,
        providedProducts,
    }
}

export default db
